import React from 'react'
import { Navigate, useRouteError } from 'react-router-dom'

import { ClientLayerError } from 'shared/errors/clientLayerError'
import { isCustomError } from 'shared/errors/helpers/guards'
import { getMetricPathname, sendHealthMetric } from 'utils/healthMetrics'
import { getComponentByRoute } from 'utils/router/tools'
import { useRedirects } from 'utils/router/utils/hooks'
import errorTrackingService from 'utils/services/errorTrackingService'

export const RouterErrorBoundary = () => {
  const error = useRouteError()
  const redirectUrl = useRedirects()
  const pathname = getMetricPathname()

  if (redirectUrl) {
    return <Navigate to={redirectUrl} />
  }

  if (error) {
    const issue = isCustomError(error) ? error : new ClientLayerError(error, { cause: error })
    errorTrackingService.logError(issue, {
      scope: 'root',
      section: 'routing',
      tags: { ErrorBoundary: true },
      fingerprint: 'router-error-boundary',
    })
    sendHealthMetric('error_boundary_event', {
      url: pathname,
      scope: 'router',
      component: getComponentByRoute(),
    })
  }

  return null
}
